import "./UIButton.scss";

import React from "react";
import UIButtonClick from "./UIButtonClick";
import UIButtonClose from "./UIButtonClose";
import UIButtonLink from "./UIButtonLink";
import UIButtonList from "./UIButtonList";
import UIButtonListOrClose from "./UIButtonListOrClose";
import UIButtonSearch from "./UIButtonSearch";

export default {
  Click: UIButtonClick,
  Link: UIButtonLink,
  ListOrClose: UIButtonListOrClose,
  List: UIButtonList,
  Close: UIButtonClose,
  Search: UIButtonSearch,
};

export interface UIButtonProps {
  type?: "button" | "submit" | "reset";
  kind?: "page" | "block";
  children?: React.ReactNode;
  icon?: string;
  label?: string;
  className?: string;
  style?: React.CSSProperties;
  attrs?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}
